/**
 * KAN-684: маршрут /register открыт только при разрешённой самостоятельной
 * регистрации. Иначе редирект на /login с сообщением в state
 * (LoginPage показывает его над формой).
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useRegistrationStatus } from '@/hooks/useRegistrationStatus';
import { REGISTRATION_CLOSED_MESSAGE } from '@/services/api/registration';

export interface LoginLocationState {
  message?: string;
}

export function RegistrationGate({ children }: { children: ReactNode }) {
  const { allowed, isLoading } = useRegistrationStatus();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-6 w-6 animate-spin text-gray-400" aria-label="Загрузка" />
      </div>
    );
  }

  if (!allowed) {
    const state: LoginLocationState = { message: REGISTRATION_CLOSED_MESSAGE };
    return <Navigate to="/login" replace state={state} />;
  }

  return <>{children}</>;
}
